<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <div class="search-bar">
        <div class="col-sm-12 no-padding">
          <div class="pull-left">
            <el-input v-model="searchQuery" @input="onInput()" :placeholder="$t('reports.search')" class="icon-search"></el-input>
          </div>
          <div class="pull-right">
            <router-link class="btn add" :title="$t('general.add') + ' ' + $t('menuSubscriptions.single')" :to="{ path: '/marketing/menu-subscriptions/add' }">
              <img src="/static/img/icons/add.png">
              {{ $t('general.add') }}
            </router-link>
          </div>
        </div>
      </div>

      <div v-loading="loading" class="msub-list">
        <div v-if="!loading && !items.length" class="card">
          <div class="card-content text-center text-muted msub-empty">{{ $t('menuSubscriptions.noSubscriptions') }}</div>
        </div>

        <div v-for="item in items" :key="'msub' + item.id" class="card msub-card" :class="{ 'is-inactive': !item.active }">
          <div class="msub-card__main">
            <img v-if="item.image_url" :src="item.image_url" class="msub-card__thumb">
            <div v-else class="msub-card__thumb msub-card__thumb--empty"><i class="fa fa-cutlery"></i></div>

            <div class="msub-card__info">
              <a class="msub-card__name" @click="edit(item)">{{ item.name }}</a>
              <div class="msub-card__meta">
                <span><i class="fa fa-map-marker"></i> {{ item.location_name || '-' }}</span>
                <span><i class="fa fa-money"></i> {{ item.price_per_day }} {{ currency }} / {{ $t('menuSubscriptions.perDayShort') }}</span>
                <span><i class="fa fa-calendar"></i> {{ $t('menuSubscriptions.durationDays', { days: item.duration_days }) }}</span>
                <span v-if="item.delivery_days.length"><i class="fa fa-truck"></i> {{ dayList(item.delivery_days) }}</span>
                <span v-if="item.delivery_hours.length"><i class="fa fa-clock-o"></i> {{ hourList(item.delivery_hours) }}</span>
              </div>
              <div class="msub-card__meta">
                <span>{{ $t('menuSubscriptions.menusCount', { count: item.menus_count }) }}<template v-if="item.default_menu_name"> · {{ $t('menuSubscriptions.defaultMenuShort') }}: {{ item.default_menu_name }}</template></span>
                <span>{{ $t('menuSubscriptions.zonesCount', { count: item.zones_count }) }}</span>
              </div>
              <div v-if="item.issues.length" class="msub-card__issues">
                <i class="fa fa-exclamation-triangle"></i>
                {{ $t('menuSubscriptions.notReady') }}: {{ issuesText(item.issues) }}
              </div>
            </div>
          </div>

          <div class="msub-card__side">
            <div class="msub-card__switch" :title="item.issues.length ? $t('menuSubscriptions.notReadyHint') : ''">
              <span class="text-muted">{{ $t('menuSubscriptions.active') }}</span>
              <p-switch v-model="item.active" type="success" @input="handleActive(item)"></p-switch>
            </div>
            <a class="btn btn-sm btn-default" @click="openSubscribers(item)">
              <i class="fa fa-users"></i> {{ $t('menuSubscribers.title') }}: {{ item.active_subscribers || 0 }}
              <small v-if="item.pending_purchases" class="text-muted">(+{{ item.pending_purchases }} {{ $t('menuSubscribers.status.pending').toLowerCase() }})</small>
            </a>
            <div class="msub-card__actions">
              <a class="msub-icon" :title="$t('menuSubscriptions.tabMenus')" @click="edit(item, 'menus')"><i class="fa fa-list"></i></a>
              <a class="msub-icon" :title="$t('menuSubscriptions.tabCalendar')" @click="edit(item, 'calendar')"><i class="fa fa-calendar"></i></a>
              <a class="msub-icon" :title="$t('general.edit')" @click="edit(item)"><i class="fa fa-pencil"></i></a>
              <a class="msub-icon msub-icon--danger" :title="$t('general.delete')" @click="handleDelete(item)"><i class="fa fa-trash-o"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import { issuesText, DAY_NAMES } from './menuSubscriptionHelpers'
  Vue.use(Input)

  export default {
    components: {
      PSwitch
    },
    data () {
      return {
        loading: true,
        searchQuery: '',
        items: [],
        currency: ''
      }
    },
    created () {
      this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso)
      this.getItems()
      this.$bus.$on('refresh', this.getItems)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.getItems)
    },
    methods: {
      requestData () {
        return {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
      },
      getItems () {
        const data = this.requestData()
        if (this.searchQuery.length >= 3) {
          data.search = this.searchQuery
        }
        this.loading = true
        this.apiRequest('/menu-subscription', 'GET', data, (response) => {
          if (response.status === true) {
            this.items = response.data || []
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      onInput () {
        if (this.searchQuery.length >= 3 || this.searchQuery.length === 0) {
          this.getItems()
        }
      },
      dayList (days) {
        return DAY_NAMES.filter(day => days.indexOf(day) !== -1)
          .map(day => this.$t('menuSubscriptions.dayShort.' + day))
          .join(', ')
      },
      hourList (hours) {
        return hours.map(hour => hour.from + '-' + hour.to).join(', ')
      },
      issuesText (issues) {
        return issuesText(this, issues)
      },
      openSubscribers (item) {
        this.$router.push({ path: '/marketing/menu-subscriptions/subscribers', query: { menu_subscription_id: item.id } }).catch(() => {})
      },
      edit (item, tab) {
        const query = tab ? { tab } : {}
        this.$router.push({ path: '/marketing/menu-subscriptions/edit/' + item.id, query }).catch(() => {})
      },
      handleActive (item) {
        const data = {
          ...this.requestData(),
          active: item.active ? 1 : 0
        }
        this.apiRequest('/menu-subscription/' + item.id + '/status', 'POST', data, (response) => {
          if (response.status === true) {
            swal({ title: '', text: this.$t('menuSubscriptions.saved'), type: 'success', showConfirmButton: false, timer: 1200 }).catch(() => {})
          } else {
            item.active = !item.active
            swal('', this.firstError(response), 'warning').catch(() => {})
          }
        })
      },
      handleDelete (item) {
        swal({
          text: this.$t('menuSubscriptions.areYouSureDelete', { name: item.name }),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (!result) {
            return
          }
          this.apiRequest('/menu-subscription/' + item.id, 'DELETE', this.requestData(), (response) => {
            if (response.status === true) {
              swal('', this.$t('menuSubscriptions.deleted'), 'success').catch(() => {})
              this.getItems()
            } else {
              swal('', this.firstError(response), 'error').catch(() => {})
            }
          })
        }).catch(() => {})
      },
      firstError (response) {
        const errors = (response && response.errors) || {}
        const key = Object.keys(errors)[0]
        if (!key) {
          return this.$t('validations.wentWrong')
        }
        return Array.isArray(errors[key]) ? errors[key][0] : errors[key]
      }
    }
  }
</script>
<style>
  .msub-list {
    min-height: 120px;
  }
  .msub-empty {
    padding: 30px 0;
  }
  .msub-card {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 14px;
    padding: 14px 18px;
    margin-bottom: 14px;
  }
  .msub-card.is-inactive .msub-card__name {
    color: #999;
  }
  .msub-card__main {
    display: flex;
    gap: 14px;
    flex: 1;
    min-width: 260px;
  }
  .msub-card__thumb {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    object-fit: cover;
    flex-shrink: 0;
  }
  .msub-card__thumb--empty {
    background: #ede7f6;
    color: #7e57c2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
  }
  .msub-card__name {
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    color: inherit;
  }
  .msub-card__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    color: #777;
    font-size: 13px;
    margin-top: 4px;
  }
  .msub-card__meta .fa {
    color: #9575cd;
    margin-right: 3px;
  }
  .msub-card__issues {
    margin-top: 6px;
    font-size: 12px;
    color: #c77700;
  }
  .msub-card__side {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
  }
  .msub-card__switch {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .msub-card__actions {
    display: flex;
    gap: 14px;
    font-size: 16px;
  }
  .msub-icon {
    cursor: pointer;
    color: #666;
  }
  .msub-icon--danger {
    color: #e53935;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/MenuSubscriptions/MenuSubscriptions.vue